  document.addEventListener('click', function (event) {
    var proxy = event.target.closest('.filters-mobile-proxy');
    if (!proxy) return;

    var section = proxy.closest('.collection-grid');
    if (!section) return;

    var realBtn = section.querySelector('#ShowFiltersBtn');
    if (!realBtn) return;

    realBtn.click();
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collection-grid').forEach(function (section) {
      var realBtn = section.querySelector('#ShowFiltersBtn');
      var proxyBtn = section.querySelector('.filters-mobile-proxy');

      if (!realBtn || !proxyBtn) return;

      var syncExpanded = function () {
        var expanded = realBtn.getAttribute('aria-expanded') || 'false';
        proxyBtn.setAttribute('aria-expanded', expanded);
      };

      syncExpanded();

      var observer = new MutationObserver(syncExpanded);
      observer.observe(realBtn, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    });
  });
  
  (function() {

    // Grip thickness helpers
    function roundGripValue(value) {
      return Math.round(value * 10) / 10;
    }

    function formatGripValue(value) {
      return roundGripValue(value).toFixed(1);
    }

    function parseGripValue(raw) {
      if (!raw) return null;

      var cleaned = String(raw)
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/,/g, ".")
        .replace(/mm$/g, "");

      if (!/^\d+(\.\d{0,2})?$/.test(cleaned)) return null;

      var number = parseFloat(cleaned);
      if (!Number.isFinite(number)) return null;

      return roundGripValue(number);
    }

    function updateGripRangeVisual(range) {
      if (!range) return;

      var min = parseFloat(range.min || "0");
      var max = parseFloat(range.max || "10");
      var value = parseFloat(range.value || min);

      var pct = max > min ? ((value - min) / (max - min)) * 100 : 0;
      pct = Math.max(0, Math.min(100, pct));

      range.style.setProperty("--grip-progress", pct + "%");
    }

    function setGripInvalid(group, isInvalid) {
      var input = group.querySelector("[data-grip-input]");
      var error = group.querySelector("[data-grip-error]");

      if (input) {
        input.classList.toggle("is-invalid", isInvalid);
      }

      if (error) {
        error.hidden = !isInvalid;
      }
    }

    function setGripValue(group, value, opts) {
      opts = opts || {};

      var hiddenTarget = group.querySelector("[data-grip-target-hidden]");      
      var min = parseFloat(group.getAttribute("data-grip-min") || "0");
      var max = parseFloat(group.getAttribute("data-grip-max") || "10");

      if (!Number.isFinite(value)) return false;

      value = roundGripValue(value);

      if (value < min || value > max) {
        setGripInvalid(group, true);
        return false;
      }

      var formatted = formatGripValue(value);

      var range = group.querySelector("[data-grip-range]");
      var input = group.querySelector("[data-grip-input]");
      var live = group.querySelector("[data-grip-live]");
      var hiddenMin = group.querySelector("[data-grip-hidden-min]");
      var hiddenMax = group.querySelector("[data-grip-hidden-max]");

      if (range) {
        range.value = formatted;
        updateGripRangeVisual(range);
      }

      if (input && !opts.skipInput) {
        input.value = formatted + "mm";
      }

      if (live) {
        var liveValue = live.querySelector(".grip-filter__badge-value");

        if (liveValue) {
          liveValue.textContent = formatted + " mm";
        } else {
          live.textContent = formatted + " mm";
        }

        live.classList.remove("is-empty");
        live.disabled = false;
      }

      if (hiddenMin) hiddenMin.value = formatted;
      if (hiddenMax) hiddenMax.value = formatted;
      if (hiddenTarget) hiddenTarget.value = formatted;
      
      setGripInvalid(group, false);
      return true;
    }

    function initGripThicknessControls(scope) {
      scope = scope || document;

      scope.querySelectorAll("[data-grip-filter]").forEach(function(group) {
        var range = group.querySelector("[data-grip-range]");
        var hiddenMin = group.querySelector("[data-grip-hidden-min]");

        if (range) {
          if (hiddenMin && hiddenMin.value) {
            range.value = hiddenMin.value;
          }
          updateGripRangeVisual(range);
        }
      });
    }    

    // Parent tabs scroller arrows + drag + custom scrollbar
    (function initParentTabsScroller(){
      var root = document.querySelector("[data-collection-tabs]");
      if (!root) return;

      var track = root.querySelector("[data-tabs-track]");
      var btnL = root.querySelector("[data-tabs-left]");
      var btnR = root.querySelector("[data-tabs-right]");
      if (!track || !btnL || !btnR) return;

      var fake = root.querySelector("[data-tabs-fakescroll]");
      var thumb = root.querySelector("[data-tabs-fakethumb]");

      function setHidden(el, hidden){
        if (!el) return;
        if (hidden) el.classList.add("is-hidden");
        else el.classList.remove("is-hidden");
      }

      function getMaxScroll(){
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      var raf = 0;
      function scheduleUpdate(){
        if (raf) return;
        raf = requestAnimationFrame(function(){
          raf = 0;
          updateButtons();
          updateFakeScrollbar();
        });
      }

      function updateButtons(){
        var maxScroll = getMaxScroll();
        var x = track.scrollLeft;

        var canScroll = maxScroll > 2;
        var canLeft = canScroll && x > 2;
        var canRight = canScroll && x < (maxScroll - 2);

        setHidden(btnL, !canLeft);
        setHidden(btnR, !canRight);
      }

      function scrollByAmount(dir){
        var amt = Math.max(220, Math.floor(track.clientWidth * 0.6));
        track.scrollBy({ left: dir * amt, behavior: "smooth" });
      }

      btnL.addEventListener("click", function(){ scrollByAmount(-1); });
      btnR.addEventListener("click", function(){ scrollByAmount(1); });

      function updateFakeScrollbar(){
        if (!fake || !thumb) return;

        var maxScroll = getMaxScroll();
        var canScroll = maxScroll > 2;

        fake.style.display = canScroll ? "block" : "none";
        if (!canScroll) return;

        var barW = fake.getBoundingClientRect().width || fake.clientWidth || 0;
        if (barW <= 0) return;

        var thumbW = Math.max(40, Math.round(barW * (track.clientWidth / track.scrollWidth)));
        thumb.style.width = thumbW + "px";

        var maxThumbX = Math.max(1, barW - thumbW);
        var x = (track.scrollLeft / maxScroll) * maxThumbX;
        thumb.style.transform = "translateX(" + x + "px)";
      }

      track.addEventListener("scroll", scheduleUpdate, { passive: true });
      window.addEventListener("resize", scheduleUpdate);

      if ("ResizeObserver" in window) {
        var ro = new ResizeObserver(function(){ scheduleUpdate(); });
        ro.observe(root);
        ro.observe(track);
        if (fake) ro.observe(fake);
      }
      if ("MutationObserver" in window) {
        var mo = new MutationObserver(function(){ scheduleUpdate(); });
        mo.observe(track, { childList: true, subtree: true, attributes: true });
      }
      track.querySelectorAll("img").forEach(function(img){
        if (img.complete) return;
        img.addEventListener("load", scheduleUpdate, { once: true });
        img.addEventListener("error", scheduleUpdate, { once: true });
      });

      // Drag-to-scroll on icons strip
      var isDown = false, didDrag = false, startX = 0, startLeft = 0;
      var DRAG_THRESHOLD = 6;

      var downLink = null;
      var downHref = "";
      var manualNavArmed = false;
      var manualNavUsed = false;

      track.addEventListener("click", function(e){
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
          return;
        }
        if (manualNavUsed) {
          e.preventDefault();
          e.stopPropagation();
          manualNavUsed = false;
        }
      }, true);

      track.addEventListener("pointerdown", function(e){
        if (typeof e.button === "number" && e.button !== 0) return;

        downLink = (e.target && e.target.closest) ? e.target.closest("a") : null;
        downHref = downLink ? (downLink.getAttribute("href") || "") : "";
        manualNavArmed = !!(downLink && downHref);
        manualNavUsed = false;

        e.preventDefault();

        isDown = true;
        didDrag = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;

        try { track.setPointerCapture(e.pointerId); } catch(err) {}

        track.classList.add("is-grabbing");
        track.classList.add("is-dragging");
      });

      track.addEventListener("pointermove", function(e){
        if (!isDown) return;

        var dx = e.clientX - startX;

        if (!didDrag && Math.abs(dx) >= DRAG_THRESHOLD) didDrag = true;

        if (didDrag) {
          manualNavArmed = false;
          track.scrollLeft = startLeft - dx;
        }
      });

      function safeNavigate(linkEl, evt){
        if (!linkEl) return;

        var href = linkEl.getAttribute("href") || "";
        if (!href || href === "#") return;

        var target = (linkEl.getAttribute("target") || "").toLowerCase();
        var newTab = target === "_blank" || (evt && (evt.metaKey || evt.ctrlKey || evt.shiftKey));

        if (newTab) {
          window.open(href, "_blank");
        } else {
          window.location.href = href;
        }
      }

      function endDrag(e){
        if (!isDown) return;
        isDown = false;

        track.classList.remove("is-grabbing");
        track.classList.remove("is-dragging");
        scheduleUpdate();

        if (!didDrag && manualNavArmed && downLink) {
          manualNavUsed = true;
          safeNavigate(downLink, e);
        }

        downLink = null;
        downHref = "";
        manualNavArmed = false;
        didDrag = false;
      }

      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      track.addEventListener("pointerleave", endDrag);

      // Native-feel scrollbar thumb dragging (with grab offset)
      if (thumb && fake) {
        var thumbDown = false;
        var grabOffset = 0;

        function sizesForDrag(){
          var maxScroll = getMaxScroll();
          var barW = fake.getBoundingClientRect().width || fake.clientWidth || 0;
          var canScroll = maxScroll > 2 && barW > 0;

          fake.style.display = canScroll ? "block" : "none";
          if (!canScroll) return { canScroll: false, maxScroll: 0, barW: 0, thumbW: 0, maxThumbX: 1 };

          var thumbW = Math.max(40, Math.round(barW * (track.clientWidth / track.scrollWidth)));
          var maxThumbX = Math.max(1, barW - thumbW);

          return { canScroll: true, maxScroll: maxScroll, barW: barW, thumbW: thumbW, maxThumbX: maxThumbX };
        }

        function clientXToThumbLeft(clientX){
          var rect = fake.getBoundingClientRect();
          var s = sizesForDrag();
          if (!s.canScroll) return 0;

          var x = clientX - rect.left - grabOffset;
          x = Math.max(0, Math.min(s.maxThumbX, x));
          return x;
        }

        function thumbLeftToScrollLeft(thumbLeft){
          var s = sizesForDrag();
          if (!s.canScroll) return 0;
          return (thumbLeft / s.maxThumbX) * s.maxScroll;
        }

        function beginThumbDrag(e, startFromTrack){
          var s = sizesForDrag();
          if (!s.canScroll) return;

          thumb.style.width = s.thumbW + "px";

          var rect = fake.getBoundingClientRect();
          var currentThumbLeft = (track.scrollLeft / s.maxScroll) * s.maxThumbX;

          if (startFromTrack) {
            grabOffset = Math.round(s.thumbW / 2);
            var targetLeft = clientXToThumbLeft(e.clientX);
            track.scrollLeft = thumbLeftToScrollLeft(targetLeft);
          } else {
            grabOffset = e.clientX - rect.left - currentThumbLeft;
            grabOffset = Math.max(0, Math.min(s.thumbW, grabOffset));
          }

          thumbDown = true;
          try { thumb.setPointerCapture(e.pointerId); } catch(err) {}
          track.classList.add("is-dragging");
          scheduleUpdate();
        }

        function moveThumb(e){
          if (!thumbDown) return;
          var targetLeft = clientXToThumbLeft(e.clientX);
          track.scrollLeft = thumbLeftToScrollLeft(targetLeft);
          scheduleUpdate();
        }

        function endThumb(){
          if (!thumbDown) return;
          thumbDown = false;
          track.classList.remove("is-dragging");
          scheduleUpdate();
        }

        thumb.addEventListener("pointerdown", function(e){
          e.preventDefault();
          e.stopPropagation();
          beginThumbDrag(e, false);
        });

        thumb.addEventListener("pointermove", function(e){
          if (!thumbDown) return;
          e.preventDefault();
          moveThumb(e);
        });

        thumb.addEventListener("pointerup", endThumb);
        thumb.addEventListener("pointercancel", endThumb);

        fake.addEventListener("pointerdown", function(e){
          if (e.target === thumb) return;
          e.preventDefault();
          beginThumbDrag(e, true);
        });

        fake.addEventListener("pointermove", function(e){
          if (!thumbDown) return;
          e.preventDefault();
          moveThumb(e);
        });

        fake.addEventListener("pointerup", endThumb);
        fake.addEventListener("pointercancel", endThumb);
      }

      scheduleUpdate();
      requestAnimationFrame(function(){ requestAnimationFrame(scheduleUpdate); });
      setTimeout(scheduleUpdate, 80);
    })();

    function toggleFilter(btn) {
      var targetSel = btn.getAttribute("data-target");
      var body = document.querySelector(targetSel);
      if (!body) return;

      var expanded = btn.getAttribute("aria-expanded") === "true";

      if (expanded) {
        body.classList.remove("is-open");
        body.classList.add("is-closed");
        btn.setAttribute("aria-expanded", "false");
      } else {
        body.classList.remove("is-closed");
        body.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    }

    document.addEventListener("click", function(e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-filter-toggle]") : null;
      if (!btn) return;
      e.preventDefault();
      toggleFilter(btn);
    });

    document.addEventListener("click", function(e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-filter-more-toggle]") : null;
      if (!btn) return;

      e.preventDefault();

      var group = btn.closest(".filter-group--collapsible");
      if (!group) return;

      var isExpanded = group.classList.toggle("is-expanded");
      btn.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    });    

    var layoutEl = document.getElementById("CollectionLayout");
    var hideFiltersBtn = document.getElementById("HideFiltersBtn");
    var hideFiltersBtnMobile = document.getElementById("HideFiltersBtnMobile");
    var showFiltersBtn = document.getElementById("ShowFiltersBtn");
    var mobileOverlay = document.getElementById("CollectionMobileOverlay");
    var showFiltersBtnText = document.getElementById("ShowFiltersBtnText");    

    function isMobileFiltersMode() {
      return window.matchMedia("(max-width: 767px)").matches;
    }

    var wasMobileFiltersMode = isMobileFiltersMode();    

    function setMobileOverlay(open) {
      if (!mobileOverlay) return;
      mobileOverlay.hidden = !open;
      mobileOverlay.classList.toggle("is-visible", open);
    }

    function syncFiltersButtonLabel() {
      if (!showFiltersBtn) return;
      showFiltersBtn.setAttribute("aria-label", "Show filters");

      if (showFiltersBtnText) {
        showFiltersBtnText.textContent = "Show Filters";
      }
    }

    function openFiltersPane() {
      if (!layoutEl) return;

      if (isMobileFiltersMode()) {
        mobileScrollY = window.pageYOffset || window.scrollY || 0;

        layoutEl.classList.add("filters-mobile-open");
        setMobileOverlay(true);

        document.documentElement.classList.add("collection-filters-lock");
        document.body.classList.add("collection-filters-lock");

        document.body.style.position = "fixed";
        document.body.style.top = "-" + mobileScrollY + "px";
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";

        if (showFiltersBtn) showFiltersBtn.setAttribute("aria-expanded", "true");

        clearMobileAutoApplyTimers();
        mobileAutoApplyPaused = false;
        mobileAutoApplySecondsRemaining = 5;
        updateMobileActionsUI();

        syncFiltersButtonLabel();
      } else {
        layoutEl.classList.remove("filters-collapsed");
      }
    }

    function closeFiltersPane() {
      if (!layoutEl) return;

      if (isMobileFiltersMode()) {
        var wasOpen = layoutEl.classList.contains("filters-mobile-open");
        var wasLocked = document.body.style.position === "fixed";

        layoutEl.classList.remove("filters-mobile-open");
        setMobileOverlay(false);

        document.documentElement.classList.remove("collection-filters-lock");
        document.body.classList.remove("collection-filters-lock");

        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";

        if (showFiltersBtn) showFiltersBtn.setAttribute("aria-expanded", "false");

        clearMobileAutoApplyTimers();
        mobileAutoApplyPaused = false;
        mobileAutoApplySecondsRemaining = 5;
        updateMobileActionsUI();

        syncFiltersButtonLabel();

        if (document.activeElement) {
          document.activeElement.blur();
        }

        if (wasOpen && wasLocked) {
          window.scrollTo(0, mobileScrollY);
        }
      } else {
        layoutEl.classList.add("filters-collapsed");
      }
    }

    if (layoutEl && showFiltersBtn) {
      if (hideFiltersBtn) {
        hideFiltersBtn.addEventListener("click", function() {
          closeFiltersPane();
        });
      }

      if (hideFiltersBtnMobile) {
        hideFiltersBtnMobile.addEventListener("click", function() {
          closeFiltersPane();
        });
      }

      showFiltersBtn.addEventListener("click", function() {
        if (isMobileFiltersMode()) {
          if (layoutEl.classList.contains("filters-mobile-open")) {
            closeFiltersPane();
          } else {
            openFiltersPane();
          }
        } else {
          layoutEl.classList.remove("filters-collapsed");
        }
      });
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener("click", function() {
        closeFiltersPane();
      });
    }

    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && layoutEl && layoutEl.classList.contains("filters-mobile-open")) {
        closeFiltersPane();
      }
    });

    function syncResponsiveFiltersState() {
      if (!layoutEl) return;

      var isMobileNow = isMobileFiltersMode();
      var crossedBreakpoint = isMobileNow !== wasMobileFiltersMode;

      // Ignore resize events that do not actually switch between mobile and desktop.
      // This prevents the mobile keyboard from closing the filters drawer.
      if (!crossedBreakpoint) {
        return;
      }

      wasMobileFiltersMode = isMobileNow;

      // When we genuinely switch layouts, reset the drawer/overlay/scroll-lock state.
      layoutEl.classList.remove("filters-mobile-open");
      setMobileOverlay(false);

      document.documentElement.classList.remove("collection-filters-lock");
      document.body.classList.remove("collection-filters-lock");

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      if (showFiltersBtn) {
        showFiltersBtn.setAttribute("aria-expanded", "false");
      }

      syncFiltersButtonLabel();

      if (!isMobileNow) {
        resetMobilePendingState();
        layoutEl.classList.remove("filters-collapsed");
      } else {
        updateMobileActionsUI();
      }
    }

    window.addEventListener("resize", syncResponsiveFiltersState);

    var filtersForm = document.getElementById("CollectionFiltersForm");
    var sortByInput = document.getElementById("CollectionSortByInput");
    var sortLabelEl = document.getElementById("SortDropdownLabel");
    var gridEl = document.getElementById("CollectionGrid");
    var pagEl = document.getElementById("CollectionPagination");
    var toolbarEl = document.getElementById("CollectionToolbar");
    var activeBarEl = document.getElementById("ActiveFiltersBar");
    var resultsCountEl = document.getElementById("CollectionResultsCount");
    var resultsEl = document.getElementById("CollectionResults");
    var shouldScrollToResultsAfterSwap = false;

    var mobileActionsEl = document.getElementById("CollectionMobileActions");
    var mobileApplyBtn = document.getElementById("CollectionMobileApplyBtn");
    var mobileApplyMessage = document.getElementById("CollectionMobileApplyMessage");
    var mobileApplyCancel = document.getElementById("CollectionMobileApplyCancel");

    var mobilePendingChanges = false;
    var mobileAutoApplyPaused = false;
    var mobileAutoApplyTimer = null;
    var mobileAutoApplyCountdown = null;
    var mobileAutoApplySecondsRemaining = 5;
    var mobileScrollY = 0;

    function getStickyHeaderOffset() {
      var siteHeader =
        document.querySelector(".site-header.is-sticky") ||
        document.querySelector(".site-header") ||
        document.querySelector("header");

      if (!siteHeader) return 16;

      var styles = window.getComputedStyle(siteHeader);
      var isStickyLike =
        styles.position === "sticky" ||
        styles.position === "fixed";

      return isStickyLike ? (siteHeader.offsetHeight + 16) : 16;
    }

    function smoothScrollToResults() {
      if (!resultsEl) return;

      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var offset = getStickyHeaderOffset();
      var rect = resultsEl.getBoundingClientRect();
      var targetTop = rect.top + window.pageYOffset - offset;

      var alreadyNearTop = rect.top >= offset && rect.top <= offset + 80;
      if (alreadyNearTop) return;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: reduceMotion ? "auto" : "smooth"
      });
    }

    if (!filtersForm || !gridEl) return;

    /* ==========================================================================
      Variant filter card modal / dialog
      ========================================================================== */

    function getOpenVariantModal() {
      return document.querySelector(".vf-modal:not([hidden])");
    }

    function removeMountedVariantModals() {
      document.querySelectorAll("body > .vf-modal[data-vf-mounted='true']").forEach(function(modal) {
        modal.remove();
      });
    }    

    function mountVariantModalsToBody() {
      document.querySelectorAll(".vf-modal").forEach(function(modal) {
        if (!modal || modal.dataset.vfMounted === "true") return;

        var modalId = modal.id;
        if (modalId) {
          document.querySelectorAll("body > .vf-modal[data-vf-mounted='true']").forEach(function(existing) {
            if (existing !== modal && existing.id === modalId) {
              existing.remove();
            }
          });
        }

        document.body.appendChild(modal);
        modal.dataset.vfMounted = "true";
      });
    }

    function lockVariantModalScroll() {
      document.documentElement.classList.add("vf-modal-lock");
      document.body.classList.add("vf-modal-lock");
    }

    function unlockVariantModalScroll() {
      document.documentElement.classList.remove("vf-modal-lock");
      document.body.classList.remove("vf-modal-lock");
    }

    mountVariantModalsToBody();

    function openVariantModal(modal) {
      if (!modal) return;

      var alreadyOpen = getOpenVariantModal();
      if (alreadyOpen && alreadyOpen !== modal) {
        closeVariantModal(alreadyOpen);
      }

      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      lockVariantModalScroll();

      var panel = modal.querySelector(".vf-modal__panel");
      if (panel) {
        panel.scrollTop = 0;
      }

      var closeBtn = modal.querySelector(".vf-modal__close");
      if (closeBtn) {
        window.requestAnimationFrame(function() {
          try {
            closeBtn.focus();
          } catch (err) {}
        });
      }
    }

    function closeVariantModal(modal) {
      if (!modal) return;

      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");

      if (!getOpenVariantModal()) {
        unlockVariantModalScroll();
      }
    }

    function closeAllVariantModals() {
      document.querySelectorAll(".vf-modal:not([hidden])").forEach(function(modal) {
        modal.hidden = true;
        modal.setAttribute("aria-hidden", "true");
      });

      unlockVariantModalScroll();
    }

    document.addEventListener("click", function(e) {
      var openBtn = e.target && e.target.closest ? e.target.closest("[data-vf-open-modal]") : null;
      if (openBtn) {
        e.preventDefault();

        var targetId = openBtn.getAttribute("data-target") || "";
        if (!targetId) return;

        var modal = document.getElementById(targetId);
        if (!modal) return;

        openVariantModal(modal);
        return;
      }

      var closeTrigger = e.target && e.target.closest ? e.target.closest("[data-vf-close-modal]") : null;
      if (closeTrigger) {
        e.preventDefault();

        var closeModal = closeTrigger.closest(".vf-modal");
        if (!closeModal) return;

        closeVariantModal(closeModal);
        return;
      }
    });

    document.addEventListener("keydown", function(e) {
      if (e.key !== "Escape") return;

      var openModal = getOpenVariantModal();
      if (!openModal) return;

      closeVariantModal(openModal);
    });

    document.addEventListener("click", function(e) {
      var modalRowLink = e.target && e.target.closest ? e.target.closest(".vf-modal__row") : null;
      if (!modalRowLink) return;

      var parentModal = modalRowLink.closest(".vf-modal");
      if (!parentModal) return;

      closeVariantModal(parentModal);
    });

    document.addEventListener("click", function(e) {
      var cardRowLink = e.target && e.target.closest ? e.target.closest(".vf-card__variant-row") : null;
      if (!cardRowLink) return;

      var href = cardRowLink.getAttribute("href");
      if (!href) return;
    });

    function resetVariantModalStateAfterSwap() {
      closeAllVariantModals();
      removeMountedVariantModals();
      mountVariantModalsToBody();
    }

    document.addEventListener("click", function(e) {
      var toggle = e.target && e.target.closest ? e.target.closest("#SortDropdownBtn") : null;
      if (!toggle) return;

      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.dropdown) return;

      e.preventDefault();
      var wrapper = toggle.closest(".dropdown");
      if (!wrapper) return;
      var menu = wrapper.querySelector(".dropdown-menu");
      if (!menu) return;

      var isShown = menu.classList.contains("show");
      document.querySelectorAll(".sort-dropdown .dropdown-menu.show").forEach(function(m){ m.classList.remove("show"); });
      if (!isShown) menu.classList.add("show");
    });

    document.addEventListener("click", function(e) {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.dropdown) return;
      var inDropdown = e.target && e.target.closest ? e.target.closest(".sort-dropdown") : null;
      if (inDropdown) return;
      document.querySelectorAll(".sort-dropdown .dropdown-menu.show").forEach(function(m){ m.classList.remove("show"); });
    });

    function serializeParams() {
      var fd = new FormData(filtersForm);
      var params = new URLSearchParams();

      fd.forEach(function(val, key) {
        if (val === null || val === undefined) return;
        var s = String(val).trim();
        if (s === "") return;
        params.append(key, s);
      });

      if (sortByInput && sortByInput.value) {
        params.set("sort_by", sortByInput.value);
      }

      return params;
    }

    function setGridUpdating(isUpdating) {
      if (!gridEl) return;
      if (isUpdating) {
        gridEl.classList.add("is-updating");
        gridEl.classList.remove("is-updated");
      } else {
        gridEl.classList.remove("is-updating");
        gridEl.classList.add("is-updated");
        setTimeout(function() {
          gridEl.classList.remove("is-updated");
        }, 450);
      }
    }

    function syncActiveLabelStates() {
      var labels = filtersForm.querySelectorAll(".filter-option");
      labels.forEach(function(lbl) {
        var input = lbl.querySelector("input[type='checkbox']");
        if (!input) return;
        if (input.checked) lbl.classList.add("is-active");
        else lbl.classList.remove("is-active");
      });
    }

    function getMobilePendingFilterCount() {
      if (!filtersForm) return 0;

      var count = 0;
      var checked = filtersForm.querySelectorAll("input[type='checkbox']:checked");
      count += checked.length;

      var numberInputs = filtersForm.querySelectorAll("input[type='number']");
      numberInputs.forEach(function(input) {
        var val = (input.value || "").trim();
        if (val !== "") count += 1;
      });

      var selects = filtersForm.querySelectorAll("select");
      selects.forEach(function(select) {
        if ((select.value || "").trim() !== "") count += 1;
      });

      var gripHiddenInputs = filtersForm.querySelectorAll("[data-grip-hidden-min]");
      gripHiddenInputs.forEach(function(input) {
        var val = (input.value || "").trim();
        if (val !== "") count += 1;
      });      

      return count;
    }

    function normalizeFilterParams(params) {
      var normalized = new URLSearchParams();

      params.forEach(function(value, key) {
        if (key === "sort_by" || key === "page") return;

        var stringValue = String(value).trim();
        if (stringValue === "") return;

        normalized.append(key, stringValue);
      });

      var entries = [];
      normalized.forEach(function(value, key) {
        entries.push([key, value]);
      });

      entries.sort(function(a, b) {
        if (a[0] === b[0]) {
          if (a[1] < b[1]) return -1;
          if (a[1] > b[1]) return 1;
          return 0;
        }
        return a[0] < b[0] ? -1 : 1;
      });

      var sorted = new URLSearchParams();
      entries.forEach(function(entry) {
        sorted.append(entry[0], entry[1]);
      });

      return sorted.toString();
    }

    function hasMobilePendingFilters() {
      var currentParams = normalizeFilterParams(serializeParams());
      var appliedParams = normalizeFilterParams(new URLSearchParams(window.location.search || ""));
      return currentParams !== appliedParams;
    }

    function updateMobileActionsUI() {
      if (!mobileActionsEl || !mobileApplyBtn || !mobileApplyMessage || !mobileApplyCancel) return;

      var isMobile = isMobileFiltersMode();

      if (!isMobile || !mobilePendingChanges) {
        mobileActionsEl.hidden = true;
        return;
      }

      mobileActionsEl.hidden = false;

      var count = getMobilePendingFilterCount();
      mobileApplyBtn.textContent = count > 0 ? ("Apply Filters (" + count + ")") : "Apply Filters";

      if (mobileAutoApplyPaused) {
        mobileApplyMessage.textContent = "Auto-apply paused until you reopen filters";
        mobileApplyCancel.hidden = true;
        return;
      }

      if (!mobileAutoApplyTimer) {
        mobileApplyMessage.textContent = "Pending changes";
        mobileApplyCancel.hidden = true;
        return;
      }

      mobileApplyMessage.textContent = "Auto-applying filters in " + mobileAutoApplySecondsRemaining + "s";
      mobileApplyCancel.hidden = false;
    }

    function clearMobileAutoApplyTimers() {
      if (mobileAutoApplyTimer) {
        clearTimeout(mobileAutoApplyTimer);
        mobileAutoApplyTimer = null;
      }

      if (mobileAutoApplyCountdown) {
        clearInterval(mobileAutoApplyCountdown);
        mobileAutoApplyCountdown = null;
      }
    }

    function resetMobilePendingState() {
      clearMobileAutoApplyTimers();
      mobilePendingChanges = false;
      mobileAutoApplyPaused = false;
      mobileAutoApplySecondsRemaining = 5;
      updateMobileActionsUI();
    }

    function startMobileAutoApplyCountdown() {
      clearMobileAutoApplyTimers();

      mobileAutoApplyPaused = false;
      mobileAutoApplySecondsRemaining = 5;
      updateMobileActionsUI();

      mobileAutoApplyCountdown = setInterval(function() {
        mobileAutoApplySecondsRemaining -= 1;

        if (mobileAutoApplySecondsRemaining <= 0) {
          clearInterval(mobileAutoApplyCountdown);
          mobileAutoApplyCountdown = null;
          mobileAutoApplySecondsRemaining = 0;
          updateMobileActionsUI();
          return;
        }

        updateMobileActionsUI();
      }, 1000);

      mobileAutoApplyTimer = setTimeout(function() {
        clearMobileAutoApplyTimers();

        if (!mobilePendingChanges || mobileAutoApplyPaused) return;

        onAnyFilterChange({ scrollToResults: true });
      }, 5000);
    }

    function queueMobileFilterApply() {
      if (!hasMobilePendingFilters()) {
        clearMobileAutoApplyTimers();
        mobilePendingChanges = false;
        mobileAutoApplyPaused = false;
        mobileAutoApplySecondsRemaining = 5;
        updateMobileActionsUI();
        return;
      }

      mobilePendingChanges = true;

      if (!mobileAutoApplyPaused) {
        startMobileAutoApplyCountdown();
      } else {
        clearMobileAutoApplyTimers();
      }

      updateMobileActionsUI();
    }

    function killTooltips(scope) {
      if (!(window.jQuery && window.jQuery.fn && window.jQuery.fn.tooltip)) return;

      window.jQuery(document.body).tooltip('hide');

      window.jQuery('.tooltip').remove();

      var root = scope || document;
      root.querySelectorAll('[aria-describedby]').forEach(function(el){
        el.removeAttribute('aria-describedby');
      });
    }

    var delegatedTooltipsReady = false;

    function initDelegatedTooltips(){
      if (delegatedTooltipsReady) return;
      if (!(window.jQuery && window.jQuery.fn && window.jQuery.fn.tooltip)) return;

      window.jQuery(document.body).tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body',
        boundary: 'window',
        trigger: 'hover focus',
        html: true
      });

      document.addEventListener('scroll', function(){
        window.jQuery(document.body).tooltip('hide');
        window.jQuery('.tooltip').remove();
      }, true);

      document.addEventListener('click', function(){
        window.jQuery(document.body).tooltip('hide');
        window.jQuery('.tooltip').remove();
      }, true);

      delegatedTooltipsReady = true;
    }

    function fetchAndSwap(params) {

      var url = filtersForm.getAttribute("action") || window.location.pathname;
      var qs = params.toString();
      var fetchUrl = qs ? (url + "?" + qs) : url;

      killTooltips(gridEl);
      setGridUpdating(true);

      fetch(fetchUrl, { credentials: "same-origin" })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newGrid = doc.getElementById("CollectionGrid");
          var newPag = doc.getElementById("CollectionPagination");
          var newFiltersForm = doc.getElementById("CollectionFiltersForm");
          var newToolbar = doc.getElementById("CollectionToolbar");

          removeMountedVariantModals();

          if (newGrid) gridEl.innerHTML = newGrid.innerHTML;
          if (newPag && pagEl) pagEl.innerHTML = newPag.innerHTML;

          if (newFiltersForm) {
            filtersForm.innerHTML = newFiltersForm.innerHTML;
          }

          initGripThicknessControls(filtersForm);

          if (toolbarEl && newToolbar) {
            toolbarEl.outerHTML = newToolbar.outerHTML;
            toolbarEl = document.getElementById("CollectionToolbar");
            activeBarEl = document.getElementById("ActiveFiltersBar");
            resultsCountEl = document.getElementById("CollectionResultsCount");
            sortByInput = document.getElementById("CollectionSortByInput");
            sortLabelEl = document.getElementById("SortDropdownLabel");
          }

          resetVariantModalStateAfterSwap();

          window.history.pushState({}, "", fetchUrl);
          syncGripFilterFromURL(document);

          syncActiveLabelStates();

          if (isMobileFiltersMode()) {
            closeFiltersPane();
          }

          if (shouldScrollToResultsAfterSwap) {
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                smoothScrollToResults();
                shouldScrollToResultsAfterSwap = false;
              });
            });
          } else {
            shouldScrollToResultsAfterSwap = false;
          }

          resetMobilePendingState();

          mobileActionsEl = document.getElementById("CollectionMobileActions");
          mobileApplyBtn = document.getElementById("CollectionMobileApplyBtn");
          mobileApplyMessage = document.getElementById("CollectionMobileApplyMessage");
          mobileApplyCancel = document.getElementById("CollectionMobileApplyCancel");
          updateMobileActionsUI();
        })
        .catch(function() {
          window.location.href = fetchUrl;
        })
        .finally(function() {
          setGridUpdating(false);
        });
    }

    window.addEventListener("popstate", function() {
      window.location.reload();
    });    

    var onAnyFilterChange = function(opts) {
      opts = opts || {};
      shouldScrollToResultsAfterSwap = !!opts.scrollToResults;

      syncActiveLabelStates();
      var params = serializeParams();
      fetchAndSwap(params);
    };

    document.addEventListener("click", function(e){
      var btn = e.target && e.target.closest ? e.target.closest("[data-price-go]") : null;
      if (!btn) return;
      e.preventDefault();

      syncActiveLabelStates();

      if (isMobileFiltersMode()) {
        queueMobileFilterApply();
        return;
      }

      onAnyFilterChange({ scrollToResults: true });
    });

    filtersForm.addEventListener("keydown", function(e){
      var t = e.target;
      if (!t) return;

      if (t.type === "number" && e.key === "Enter") {
        e.preventDefault();

        syncActiveLabelStates();

        if (isMobileFiltersMode()) {
          queueMobileFilterApply();
          return;
        }

        onAnyFilterChange({ scrollToResults: true });
      }
    });

    document.addEventListener("click", function(e) {
      var item = e.target && e.target.closest ? e.target.closest("[data-sort-value]") : null;
      if (!item) return;

      e.preventDefault();

      var val = item.getAttribute("data-sort-value") || "";
      var label = item.getAttribute("data-sort-label") || item.textContent || "";

      if (sortByInput) sortByInput.value = val;
      if (sortLabelEl) sortLabelEl.textContent = label.trim();

      var menu = item.closest(".dropdown-menu");
      if (menu) {
        menu.querySelectorAll(".dropdown-item").forEach(function(el){ el.classList.remove("active"); });
        item.classList.add("active");
        menu.classList.remove("show");
      }

      onAnyFilterChange({ scrollToResults: true });
    });

    filtersForm.addEventListener("change", function(e) {
      var target = e.target;
      if (!target) return;
      if (target.type === "checkbox" || target.tagName === "SELECT") {
        syncActiveLabelStates();

        if (isMobileFiltersMode()) {
          queueMobileFilterApply();
          return;
        }

        onAnyFilterChange({ scrollToResults: true });
      }
    });

    document.addEventListener("click", function(e) {
      var applyBtn = e.target && e.target.closest ? e.target.closest("#CollectionMobileApplyBtn") : null;
      if (applyBtn) {
        e.preventDefault();
        if (!mobilePendingChanges) return;

        clearMobileAutoApplyTimers();
        mobileAutoApplyPaused = false;
        onAnyFilterChange({ scrollToResults: true });
        return;
      }

      var cancelBtn = e.target && e.target.closest ? e.target.closest("#CollectionMobileApplyCancel") : null;
      if (cancelBtn) {
        e.preventDefault();
        clearMobileAutoApplyTimers();
        mobileAutoApplyPaused = true;
        updateMobileActionsUI();
      }
    });    

    document.addEventListener("click", function(e) {
      var a = e.target && e.target.closest ? e.target.closest("#CollectionPagination a") : null;
      if (!a) return;

      var href = a.getAttribute("href");
      if (!href) return;

      e.preventDefault();
      killTooltips(gridEl);
      setGridUpdating(true);

      fetch(href, { credentials: "same-origin" })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newGrid = doc.getElementById("CollectionGrid");
          var newPag = doc.getElementById("CollectionPagination");
          var newFiltersForm = doc.getElementById("CollectionFiltersForm");
          var newToolbar = doc.getElementById("CollectionToolbar");

          if (newGrid) gridEl.innerHTML = newGrid.innerHTML;
          if (newPag && pagEl) pagEl.innerHTML = newPag.innerHTML;

          if (newFiltersForm) {
            filtersForm.innerHTML = newFiltersForm.innerHTML;
          }

          initGripThicknessControls(filtersForm);

          if (toolbarEl && newToolbar) {
            toolbarEl.outerHTML = newToolbar.outerHTML;
            toolbarEl = document.getElementById("CollectionToolbar");
            activeBarEl = document.getElementById("ActiveFiltersBar");
            resultsCountEl = document.getElementById("CollectionResultsCount");
            sortByInput = document.getElementById("CollectionSortByInput");
            sortLabelEl = document.getElementById("SortDropdownLabel");
          }

          resetVariantModalStateAfterSwap();          

          window.history.pushState({}, "", href);
          syncGripFilterFromURL(document);
          syncActiveLabelStates();

          resetMobilePendingState();

          mobileActionsEl = document.getElementById("CollectionMobileActions");
          mobileApplyBtn = document.getElementById("CollectionMobileApplyBtn");
          mobileApplyMessage = document.getElementById("CollectionMobileApplyMessage");
          mobileApplyCancel = document.getElementById("CollectionMobileApplyCancel");
          updateMobileActionsUI();          
        })
        .catch(function() {
          window.location.href = href;
        })
        .finally(function() {
          setGridUpdating(false);
        });
    });

    document.addEventListener("click", function(e){
      var link = e.target && e.target.closest ? e.target.closest("[data-filter-remove],[data-filter-clear]") : null;
      if (!link) return;

      var href = link.getAttribute("href") || "";

      e.preventDefault();
      shouldScrollToResultsAfterSwap = true;

      try {
        var params;

        if (link.hasAttribute("data-grip-remove")) {
          params = new URLSearchParams(window.location.search || "");

          var gripMinParam = link.getAttribute("data-grip-min-param") || "filter.v.m.custom.grip_min_mm.lte";
          var gripMaxParam = link.getAttribute("data-grip-max-param") || "filter.v.m.custom.grip_max_mm.gte";

          params.delete(gripMinParam);
          params.delete(gripMaxParam);
          params.delete("page");
        } else if (link.hasAttribute("data-price-remove")) {
          params = new URLSearchParams(window.location.search || "");

          var minParam = link.getAttribute("data-price-min-param") || "filter.v.price.gte";
          var maxParam = link.getAttribute("data-price-max-param") || "filter.v.price.lte";

          params.delete(minParam);
          params.delete(maxParam);
          params.delete("page");
        } else if (link.hasAttribute("data-group-remove")) {
          params = new URLSearchParams(window.location.search || "");

          var groupParam = link.getAttribute("data-group-param") || "";
          if (groupParam) {
            params.delete(groupParam);
          }

          params.delete("page");
        } else {
          if (!href) return;

          var u = new URL(href, window.location.origin);
          params = new URLSearchParams(u.search || "");
        }

        fetchAndSwap(params);
      } catch(err) {
        if (href) {
          window.location.href = href;
        }
      }
    });

    // Grip filter events
    document.addEventListener("input", function(e) {
      var range = e.target.closest("[data-grip-range]");
      if (range) {
        var group = range.closest("[data-grip-filter]");
        if (!group) return;
        setGripValue(group, parseFloat(range.value));

        if (isMobileFiltersMode()) {
          queueMobileFilterApply();
        }

        return;
      }

      var input = e.target.closest("[data-grip-input]");
      if (input) {
        var group = input.closest("[data-grip-filter]");
        if (!group) return;

        var parsed = parseGripValue(input.value);
        if (parsed === null) {
          setGripInvalid(group, input.value.trim() !== "");
          return;
        }

        setGripValue(group, parsed, { skipInput: true });
        if (isMobileFiltersMode()) {
          queueMobileFilterApply();
        }        
      }
    });

    document.addEventListener("click", function(e) {
      var btn = e.target.closest("[data-grip-clear]");
      if (!btn) return;

      e.preventDefault();

      var group = btn.closest("[data-grip-filter]");
      if (!group) return;

      var hiddenMin = group.querySelector("[data-grip-hidden-min]");
      var hiddenMax = group.querySelector("[data-grip-hidden-max]");
      var hiddenTarget = group.querySelector("[data-grip-target-hidden]");
      var input = group.querySelector("[data-grip-input]");
      var live = group.querySelector("[data-grip-live]");
      var range = group.querySelector("[data-grip-range]");

      if (hiddenMin) hiddenMin.value = "";
      if (hiddenMax) hiddenMax.value = "";
      if (hiddenTarget) hiddenTarget.value = "";
      if (input) input.value = "";

      if (live) {
        var liveValue = live.querySelector(".grip-filter__badge-value");

        if (liveValue) {
          liveValue.textContent = "Select mm";
        } else {
          live.textContent = "Select mm";
        }

        live.classList.add("is-empty");
        live.disabled = true;
      }      

      if (range) {
        range.value = range.min || "0";
        updateGripRangeVisual(range);
      }

      setGripInvalid(group, false);

      var params = new URLSearchParams(window.location.search || "");
      params.delete("filter.v.m.custom.grip_min_mm.lte");
      params.delete("page");

      fetchAndSwap(params);
    });    

    document.addEventListener("click", function(e) {
      var btn = e.target.closest("[data-grip-go]");
      if (!btn) return;

      e.preventDefault();

      var group = btn.closest("[data-grip-filter]");
      if (!group) return;

      var input = group.querySelector("[data-grip-input]");
      var parsed = parseGripValue(input.value);

      if (parsed === null) {
        setGripInvalid(group, true);
        return;
      }

      if (!setGripValue(group, parsed)) return;

      if (isMobileFiltersMode()) {
        queueMobileFilterApply();
        return;
      }

      onAnyFilterChange({ scrollToResults: true });
    });    


    syncActiveLabelStates();
    initDelegatedTooltips();
    syncFiltersButtonLabel();
    syncResponsiveFiltersState();
    updateMobileActionsUI();
    initGripThicknessControls(document);
    syncGripFilterFromURL(document);

    function syncGripFilterFromURL(scope) {
      scope = scope || document;

      var params = new URLSearchParams(window.location.search);
      var grip = params.get("filter.v.m.custom.grip_min_mm.lte");

      if (!grip) return;

      var value = parseFloat(grip);
      if (!Number.isFinite(value)) return;

      var group = scope.querySelector("[data-grip-filter]") || document.querySelector("[data-grip-filter]");
      if (!group) return;

      setGripValue(group, value);

      var body = document.querySelector("#FilterGroup-GripThickness");
      var toggle = document.querySelector('[data-target="#FilterGroup-GripThickness"]');

      if (body) {
        body.classList.remove("is-closed");
        body.classList.add("is-open");
      }

      if (toggle) {
        toggle.setAttribute("aria-expanded", "true");
      }
    }

  })();